
import { useAllUserPresence } from "./AllUsersPresenceProvider";

export const useUserStatus = (userId) => {
    const all = useAllUserPresence();
    const online = userId && all?.has(userId) ? "online" : "offline";

    return { online };
};
